// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListPreview_wrapper__1S8ty","header":"ListPreview_header__3n6uA","title":"ListPreview_title__3znKO","link":"ListPreview_link__3Odyt","list":"ListPreview_list__2R_XT"};